const searchStrip = {
  hotels: "Hotels",
  city: "City",
  checkIn: "Check In",
  checkOut: "Check Out",
  date: "Date",
  persons: "Persons",
  adults: "Adults",
  rooms: "Rooms",
  editSearch: "Edit Search",
  newSearch: "New Search",
  listView: "List View",
  mapView: "Map View",
};

export default searchStrip;
